import { render } from "./FormSubmitMessage.vue?vue&type=template&id=9ebf2c28"
import script from "./FormSubmitMessage.vue?vue&type=script&lang=js"
export * from "./FormSubmitMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__